// Generated by `npm --workspace @pleio/icons run generate`, do not edit.
import { type ForwardedRef, forwardRef } from 'react'

import type { IconProps } from '../types'

export const ArrowRightIcon = forwardRef<SVGSVGElement, IconProps>((
    { title, titleId, ...props }: IconProps,
    ref: ForwardedRef<SVGSVGElement>,
) => (
    <svg xmlns="http://www.w3.org/2000/svg" width={14} height={14} viewBox="0 0 14 14" display="block" focusable="false" role="img" aria-hidden="true" ref={ref} aria-labelledby={titleId} {...props}>{title ? <title id={titleId}>{title}</title> : null}<defs><path id="path-1" d="M0 0h14v14H0z" /></defs><g id="arrow-right" fill="none" fillRule="evenodd" stroke="none"><g id="arrow-right-fat" fill="currentColor"><path id="Path" d="M13.364 5.496v3h-7.62l2.741 2.742-2.121 2.122L0 6.996 6.364.632l2.121 2.121-2.742 2.742z" transform="matrix(-1 0 0 1 13.364 0)" /></g></g></svg>
))
